// old

import { Router } from '@angular/router';
import { DOCUMENT} from '@angular/common';
import { PageScrollService, PageScrollConfig, PageScrollInstance } from 'ng2-page-scroll';
import { Component, Inject, ViewChild, ElementRef, OnInit } from '@angular/core';
// import { ScrollAbleService } from './../../../shared/scroll-able.service';
import { Subscription } from 'rxjs/Rx';
import { SidebarScrollService } from '../../../services/sidebar-scroll.service';
import { PublicationsService } from '../../../services/publications.service';
import { Observable } from 'rxjs/Observable';


// @Component({
//   selector: 'app-research-publicate',
//   templateUrl: './research-publicate.component.html',
//   styleUrls: ['./research-publicate.component.scss']
// })
// export class ResearchPublicateComponent implements OnInit {


//   id: string;
//   subscription: Subscription;
//   imgPath:string = './../../../../assets/Contents/';

//   pubs$:Observable<any[]>;

//   constructor(
//     private sidebarScrollService:SidebarScrollService,
//     private publicationsService:PublicationsService,
//     private pageScrollService: PageScrollService,
//     private router:Router,
//     @Inject(DOCUMENT) private document: any
//     ) {
//     PageScrollConfig.defaultScrollOffset = 110;
//     PageScrollConfig.defaultDuration = 300;
//     this.subscription = this.sidebarScrollService.getScroll()
//       .subscribe(name => { 
//         this.clickScrollTo(name);
//       })

//    }

//   ngOnInit() {
//     this.pubs$ = this.publicationsService.findArgPublications('international');
//   }

//   clickScrollTo(name) {
//     let scrollTo = '#' + name;
//     let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, scrollTo);
//     this.pageScrollService.start(pageScrollInstance);
//   }

//   navigateTo(link) {
//     this.router.navigate(['main/international/individual', link]);
//   }

// }

// import { Router } from '@angular/router';
// import { DOCUMENT } from '@angular/common';
// import { Component, Inject, OnInit } from '@angular/core';
// import { Subscription } from 'rxjs/Subscription';
// import { SidebarScrollService } from '../../../services/sidebar-scroll.service';
// import { PublicationsService } from '../../../services/publications.service';
// import { Observable } from 'rxjs/Observable';

// import 'rxjs/add/operator/map';
// import 'rxjs/add/operator/first';
// import 'rxjs/add/operator/shareReplay';

@Component({
  selector: 'app-research-publicate',
  templateUrl: './research-publicate.component.html',
  styleUrls: ['./research-publicate.component.scss']
})
export class ResearchPublicateComponent implements OnInit {

  subscription: Subscription;
  totalPages: number = 0;
  currentPage: number = 1;
  imgPath:string = './../../../../assets/Contents/';

  pubs$:Observable<any[]>;
  cachedData: { [key: number]: Observable<any[]> } = {};

  constructor(
    private sidebarScrollService: SidebarScrollService,
    private publicationsService: PublicationsService,
    private pageScrollService: PageScrollService, // 02/17/25 추가
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) {
    this.subscription = this.sidebarScrollService.getScroll()
      .subscribe(name => {
        this.clickScrollTo(name);
      });
   }

  ngOnInit() {
    // this.pubs$ = this.publicationsService.findArgPublications('international');
    // 06/18/24 modified
    this.loadTotalPublicationsCount('international');
    this.loadPublications('international', this.currentPage);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  clickScrollTo(name) {
    // 06/18/24 added
    this.publicationsService.findPageNumberByTypeAndYear('international', name).subscribe(page => {
      this.navigateToPage(page).then(() => {
        setTimeout(() => {
          let scrollTo = '#' + name;
          let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, scrollTo);
          this.pageScrollService.start(pageScrollInstance);
        }, 500);
      });
    });
    // let scrollTo = '#' + name;
    // let pageScrollInstance: PageScrollInstance = PageScrollInstance.simpleInstance(this.document, scrollTo);
    // this.pageScrollService.start(pageScrollInstance);
  }

  // 06/19/24 modified
  navigateTo(link) {
    // let dest = `/main/international/individual/${link}`;
    // this.router.navigateByUrl(dest);
    this.router.navigate(['main/international/individual', link]);
  }

  // 06/18/24 added
  loadPublications(type: string, page: number) {
    if (!this.cachedData[page]) {
      this.cachedData[page] = this.publicationsService.findPublicationsByTypeAndPage(type, page);
    }
    this.pubs$ = this.cachedData[page];
  }


  // 06/18/24 added
  loadTotalPublicationsCount(type: string) {
    this.publicationsService.getPublicationPagesByType(type)
      .subscribe(
        (pages: number) => {
          this.totalPages = pages;
        },
        error => {
          console.error('Error fetching data:', error);
        }
      );
  }

  // 06/18/24 added
  navigateToPage(page: number) {
    if (page >= 1 && page <= this.totalPages && page != this.currentPage) {
      this.currentPage = page;
      this.loadPublications('international', page);
      // this.router.navigate(['main/international', page]); 
    }
    return Promise.resolve();
  }

  // 06/18/24 added
  getPageNumbers(): number[] {
    return Array(this.totalPages).fill(0).map((x, i) => i + 1);
  }
}



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-publicate/research-publicate.component.ts